export const setMaterials = (materials) => {
    return {
        type: 'SET_MATERIALS',
        materials,
    };
};

export const setLowHours = (lowHours) => {
    return {
        type: 'SET_LOW_HOURS',
        lowHours,
    };
};

export const addMaterial = (material) => {
    return {
        type: 'ADD_MATERIAL',
        material,
    };
};

export const removeMaterial = (material) => {
    return {
        type: 'REMOVE_MATERIAL',
        material,
    };
};

export const clearMaterials = () => {
    return {
        type: 'CLEAR_MATERIALS'
    };
};

export const setFilter = (filter) => {
    return {
        type: 'SET_FILTER_STOCK',
        filter
    };
};

export const clearFilter = () => {
    return {
        type: 'CLEAR_FILTER',
    };
};

export const setPartnumbers = (partnumbers) => {
    return {
        type: 'SET_PARTNUMBERS',
        partnumbers,
    };
};
export const setLogs = (logs) => {
    return {
        type: 'SET_LOGS',
        logs,
    };
};

export const selectLog = (log) => {
    return {
        type: 'SELECT_LOG',
        log,
    };
};

export const setPartnumber = (partnumber) => {
    return {
        type: 'SET_PARTNUMBER',
        partnumber
    };
};

export const setResourceStock = (resourceStock) => {
    return {
        type: 'SET_RESOURCE_STOCK',
        resourceStock,
    };
};

export const setAreas = (areas) => {
    return {
        type: 'SET_AREAS',
        areas,
    };
};

export const setArea = (area) => {
    return {
        type: 'SET_AREA',
        area,
    };
};

export const setUles = (ules) => {
    return {
        type: 'SET_ULES',
        ules,
    };
};

export const setUle = (ule) => {
    return {
        type: 'SET_ULE',
        ule,
    };
};

export const setVehicles = (vehicles) => {
    return {
        type: 'SET_VEHICLES',
        vehicles,
    };
};

export const setVehicle = (vehicle) => {
    return {
        type: 'SET_VEHICLE',
        vehicle,
    };
};

export const setQuestions = (questions) => {
    return {
        type: 'SET_QUESTIONS',
        questions,
    };
};

export const setQuestion = (question) => {
    return {
        type: 'SET_QUESTION',
        question,
    };
};

export const setDeem = (deem) => {
    return {
        type: 'SET_DEEM',
        deem,
    };
};

export const setDeems = (deems) => {
    return {
        type: 'SET_DEEMS',
        deems,
    };
};

export const setSqp = (sqp) => {
    return {
        type: 'SET_SQP',
        sqp,
    };
};

export const setSqps = (sqps) => {
    return {
        type: 'SET_SQPS',
        sqps,
    };
};

export const setMailers = (mailers) => {
    return {
        type: 'SET_MAILERS',
        mailers,
    };
};

export const setMailer = (mailer) => {
    return {
        type: 'SET_MAILER',
        mailer,
    };
};


export const setPalletsLabelPaged = (palletsLabels) => {
    return {
        type: 'SET_PALLETS_LABEL_PAGED',
        palletsLabels,
    };
};

export const setPalletLabel = (palletLabel) => {
    return {
        type: 'SET_PALLET_LABEL',
        palletLabel,
    };
};

export const setDiffusions = (items) => {
    return {
        type: 'SET_DIFFUSIONS',
        items,
    };
};

export const setDiffusionFilter = (filter) => {
    return {
        type: 'SET_FILTER_DIFFUSION',
        filter
    };
};

export const selectDiffusionLog = (log) => {
    return {
        type: 'SELECT_DIFFUSION_LOG',
        diffusionLog: log,
    };
};